var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Session Recordings","size":"lg","id":"recordingsModal","ok-only":""}},[_c('div',{staticStyle:{"color":"red","margin-bottom":"1em"}},[_vm._v("Recordings are only available to download for 7 days from creation")]),_c('RecordingsList',{attrs:{"sessionId":_vm.sessionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }